import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const OrderedList = ({ node }: RichTextContentProps) => {
  return (
    <ol>
      <RichTextContent node={node} />
    </ol>
  );
};

export default OrderedList;
